import SiteHeader from "../components/SiteHeader";
import SiteFooter from "../components/SiteFooter";
import { HeroSection } from "../components/landing/HeroSection";
import { OurWorkSection } from "../components/landing/OurWorkSection";
import { LookEstablishedSection } from "../components/landing/LookEstablishedSection";
import { PricingSection } from "../components/landing/PricingSection";
import { FounderSection } from "../components/landing/FounderSection";
import { FAQSection } from "../components/landing/FAQSection";
import { FinalCTASection } from "../components/landing/FinalCTASection";

/* ============================================================
   READYTRADES — LANDING PAGE
   Concept: "Built properly from day one."
   Each numbered section lives in its own file under
   /components/landing/. This page just composes them.
   ============================================================ */

const LandingPage = () => (
  <div className="min-h-screen bg-[color:var(--bg)] overflow-x-hidden" data-testid="landing-page">
    <SiteHeader />
    <HeroSection />
    <OurWorkSection />
    <LookEstablishedSection />
    <PricingSection />
    <FounderSection />
    <FAQSection />
    <FinalCTASection />
    <SiteFooter />
  </div>
);

export default LandingPage;
